import DashboardLayoutTitleWithPartner from '../../layouts/DashboardLayout/DashboardLayoutTitleWithPartner';
import OrdersHistory from './OrdersHistory/OrdersHistory';

function Orders() {
  return (
    <>
      <DashboardLayoutTitleWithPartner
        heading="Orders"
        title="View your order history"
      />
      <OrdersHistory />
    </>
  );
}

export default Orders;
